import React, { useState } from "react";
import {
  Navbar,
  Nav,
  Container,
  NavDropdown,
  Offcanvas,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../Assets/shyam.png";
import "./Navbarmenu.css";

export const Navbarmenu = () => {
  const [fontSize, setFontSize] = useState(16);
  const [showMenu, setShowMenu] = useState(false);

  const routes = [
    { name: "Home", href: "/" },
    {
      name: "Cement",
      submenu: [
        { name: "Chetak", href: "/Cement" },
        { name: "Perfect Plus", href: "/Cement" },
      ],
    },
    {
      name: "Tiles",
      submenu: [
        { name: "Floor", href: "/Floor" },
        { name: "Wall", href: "/Wall" },
        { name: "Parking", href: "/Parking" },
      ],
    },
    {
      name: "Sand",
      submenu: [
        { name: "River", href: "/River" },
        { name: "Concrete", href: "/Concrete" },
      ],
    },
    {
      name: "Bricks",href: "/Bricks" 
    },
    {
      name: "Service",href: "/Service" 
    },
    
  ];

  const toggleMenu = () => setShowMenu(!showMenu);
  const closeMenu = () => setShowMenu(false);
  const increaseFont = () => setFontSize((f) => f + 1);
  const decreaseFont = () => setFontSize((f) => (f > 12 ? f - 1 : f));

  return (
    <Navbar expand="lg" className="nav-transparent" style={{ fontSize: `${fontSize}px` }}>
      <Container fluid>
        <Row className="w-100 align-items-center">
          <Col xs={6} lg={3} className="d-flex align-items-center">
            <img src={logo} alt="Logo" className="brand-logo me-2" />
            <span className="brand-name">Shree Shyam Enterprises</span>
          </Col>

          <Col xs={6} lg={9} className="d-flex flex-column align-items-end">
            {/* Top Row Controls */}
            <div className="d-flex align-items-center gap-2 mb-2">
			<div className="contact-icon-wrapper">
                <i className="fas fa-phone contact-icon"></i>
                <div className="contact-icons">
                  <i className="fab fa-instagram"></i>
                  <i className="fas fa-mobile-alt"></i>
                  <i className="fab fa-whatsapp"></i>
                  <i className="fas fa-map-marker-alt"></i>
                </div>
              </div>
                <button onClick={increaseFont} className="btn-icon">A+</button>
                <button onClick={decreaseFont} className="btn-icon">A-</button>
              
              <select className="form-select form-select-sm lang-select">
                <option value="en">EN</option>
                <option value="hi">हिन्दी</option>
              </select>
            
            </div>

            {/* Bottom Row Menu */}
            <div className="d-none d-lg-flex bottom-nav gap-3 align-items-center">
              <Nav>
                {routes.map((route, i) =>
                  route.submenu ? (
                    <NavDropdown title={route.name} key={i} className="animated-dropdown">
                      {route.submenu.map((sub, j) => (
                        <NavDropdown.Item as={Link} to={sub.href} key={j}>
                          {sub.name}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  ) : (
                    <Nav.Link as={Link} to={route.href} key={i} className="animated-link">
                      {route.name}
                    </Nav.Link>
                  )
                )}
                <Nav.Link className="animated-link"><i className="fas fa-search"></i></Nav.Link>
                <Nav.Link as={Link} to="/login" className="animated-link"><i className="fas fa-sign-in-alt"></i></Nav.Link>
                <Nav.Link className="animated-link"><i className="fas fa-shopping-cart"></i></Nav.Link>
              </Nav>
            </div>

            <Navbar.Toggle onClick={toggleMenu} className="d-lg-none" />
          </Col>
        </Row>

			<Offcanvas
			show={showMenu}
			onHide={closeMenu}
			placement="end"
			className="offcanvas" 
			backdrop={false} 
			>
          <Offcanvas.Header>
            <Offcanvas.Title>☰Menu</Offcanvas.Title>
            <Button variant="outline-secondary" onClick={closeMenu}>&times;</Button>
          </Offcanvas.Header>
		  {/* <Offcanvas.Header closeButton>
  		<Offcanvas.Title className="offcanvas-title"> Menu</Offcanvas.Title>
		</Offcanvas.Header> */}

<Offcanvas.Body>
  <div className="offcanvas-content">
    {/* {routes.map((route, i) => (
      <div key={i} className="offcanvas-link">
        <strong className="main-link">{route.name}</strong>
        {route.submenu && (
          <ul className="submenu-list">
            {route.submenu.map((sub, j) => (
              <li key={j}>
                <Link to={sub.href} className="submenu-item">
                  {sub.name}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    ))} */}
			{routes.map((route, i) =>
                  route.submenu ? (
                    <NavDropdown title={route.name} key={i} className="animated-dropdown">
                      {route.submenu.map((sub, j) => (
                        <NavDropdown.Item as={Link} to={sub.href} key={j}>
                          {sub.name}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  ) : (
                    <Nav.Link as={Link} to={route.href} key={i} className="animated-link">
                      {route.name}
                    </Nav.Link>
                  )
                )}
    <div className="offcanvas-icons">
      <i className="fas fa-search icon"></i>
      <Link to="/login"><i className="fas fa-sign-in-alt icon"></i></Link>
      <i className="fas fa-shopping-cart icon"></i>
    </div>
  </div>
</Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
  );
};
